export const REVIEWS = [
  {
    name: "Amazon Customer",
    title: "Great little books",
    text: "Great little books — we have the set of 3. My grandchildren enjoy learning to read with them. Fantastic illustrations relevant to the stories.",
    date: "April 2025",
    book: "Bailey, What Can You Do?",
  },
  {
    name: "Kathryn",
    title: "Relatable character",
    text: "The story was engaging and an easy read. My son read it to his little sister — she loved it. Even though she's three she was able to create her own story just by looking at the illustrations.",
    date: "October 2024",
    book: "Bailey, What Can You Do?",
  },
  {
    name: "Yvonne",
    title: "Thought provoking, especially for young boys of colour",
    text: "I bought this book following a chance meeting with the author on the underground. My two year old grandson loves it! Will definitely purchase another.",
    date: "August 2026",
    book: "Bailey, What Can You Do?",
  },
  {
    name: "koko_one",
    title: "Bailey, best new friend",
    text: "A delightful book to share with a child. It encourages talking about Bailey's day as well as your child's own day. Maybe they could tidy up like Bailey?! Beautiful illustrations make this a book to keep.",
    date: "October 2024",
    book: "Bailey, What Can You Do?",
  },
  {
    name: "Amazon Customer",
    title: "Great illustrations",
    text: "The book Bailey teaches children the day to day things, which allows them to grow. The illustrations are amazing and self explanatory. My grand nephew loves this book.",
    date: "October 2024",
    book: "Bailey, What Can You Do?",
  },
  {
    name: "Amazon Customer",
    title: "Top quality",
    text: "Got this book for my granddaughter who's 4 yrs. Love the quality of the book, the visuals and wording. I'm looking forward to getting the collection of Damali Allison's literature — great job.",
    date: "November 2024",
    book: "Bailey, What Can You Do?",
  },
  {
    name: "Marsha",
    title: "Lovely book",
    text: "I loved this book — my friend's son loved it and wants to be Bailey. Beautifully written and illustrations are wonderful and very modern. A must buy!",
    date: "October 2024",
    book: "Bailey, What Can You Do?",
  },
];
